import { provide, inject } from '@vue/composition-api'
import { Store } from 'vuex'
import VueRouter, { Route } from 'vue-router'
const StoreSymbol = Symbol()
const RouteSymbol = Symbol()
const RouterSymbol = Symbol()
export function provideStore(store: Store<any>) {
    provide(StoreSymbol, store)
}
export function useStore() {
    const store = inject<Store<any>>(StoreSymbol) as Store<any>
    // if (!store) {
    // }
    return store
}
export function provideRouter(router: VueRouter) {
    provide(RouterSymbol, router)
}
export function useRouter() {
    const router = inject<VueRouter>(RouterSymbol) as VueRouter
    // if (!router) {
    // }
    return router
}
export function provideRoute(route: Route) {
    provide(RouteSymbol, route)
}

export function useRoute() {
    const route = inject<Route>(RouteSymbol) as Route
    // if (!route) {
    // }
    return route
}

export interface IPageNation {
    pageNum: number
    pageSize: number
    total: number
}
